import React from 'react';
import { BooleanInput, Edit, SelectArrayInput, SimpleForm, TextInput } from 'react-admin';
import ManyToManyInput from './forms/ManyToManyInput';

const SOCIAL_PROVIDER_CHOICES = [
    { id: 'google', name: 'Google' },
    { id: 'facebook', name: 'Facebook' },
    { id: 'fieldview', name: 'FieldView' },
];

// An empty selection means "show no providers", so we normalize it to null
// (null and an empty list are equivalent on the backend). Empty text for the
// optional login title / button is likewise normalized to null so the backend
// treats it as "unset" (no title shown / default button label).
const transform = (data: any) => ({
    ...data,
    enabled_social_providers: data.enabled_social_providers?.length
        ? data.enabled_social_providers
        : null,
    oauth_login_title: data.oauth_login_title?.trim() ? data.oauth_login_title : null,
    oauth_login_button_text: data.oauth_login_button_text?.trim()
        ? data.oauth_login_button_text
        : null,
});

const ExternalUserEdit = (props: any) => {
    return (
        <Edit title='Edit a User' transform={transform}>
            <SimpleForm>
                <TextInput source='id' />
                <TextInput source='name' />
                <TextInput source='description' />
                <TextInput source='client_id' />
                <SelectArrayInput
                    source='enabled_social_providers'
                    label='Enabled Social Providers'
                    choices={SOCIAL_PROVIDER_CHOICES}
                    helperText='Empty = no providers shown on the login form.'
                />
                <BooleanInput
                    source='hide_register_on_oauth'
                    label='Hide register on login form'
                    helperText='When enabled, the "register" prompt is hidden on the OAuth login form.'
                />
                <TextInput
                    source='oauth_login_title'
                    label='Login form title'
                    helperText='Optional heading shown above the email field on the login form. Empty = no title shown.'
                />
                <TextInput
                    source='oauth_login_button_text'
                    label='Login button text'
                    helperText='Optional label for the login button. Empty = default ("Ingresar").'
                />
                <ManyToManyInput reference='groups' referenceField='group_id' label='Groups' />
            </SimpleForm>
        </Edit>
    );
};

export default ExternalUserEdit;
